import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=d6b38b86"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports